import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Project } from '@src/app/models/project';
import { Projecttemplate } from '../model/projecttemplate';

@Injectable({
  providedIn: 'root'
})
export class ProjecttemplatecreateService {

  constructor(private http:HttpClient) { }
  createTemplate(project:Projecttemplate){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }//POST	/organization/{organizationId}/template
    return this.http.post<string>(environment.apiUrl+'/organization/'+project.organizationId+"/template",project,httpOptions);
 
  }
}
